/**
 * Web mock for react-native-fs - not used on web (export uses download/print)
 */
module.exports = {
  CachesDirectoryPath: '/tmp',
  DocumentDirectoryPath: '/tmp',
  writeFile: () => Promise.resolve(),
  unlink: () => Promise.resolve(),
};
